import { Field, Form, Formik } from "formik";
import moment from 'moment';
import "moment-timezone";
import queryString from 'query-string';
import React, { Component } from "react";
import { Button, ControlLabel } from 'react-bootstrap';
import Alert from 'react-s-alert';
import * as Yup from "yup";
import AuthContext from '../auth-context';
import FormikDatetime from "../Shared/FormikDateTime";
import FormikFormControl from '../Shared/Forms/FormikFormControl';
import FormikInputControl from '../Shared/Forms/FormikInputControl';
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";
import DealsService from '../utils/DealsService';
import UsersService from '../utils/UsersService';

class SaleMadeForm extends Component {
  static contextType = AuthContext;
  state = {}

  constructor(props) {
    super(props);
    UsersService.allUsers().then((data) => {
      this.setState({ users: data })
    })
  }

  render() {
    const authStore = this.context

    const { onCancelSubmit, deal, saleType } = this.props

    const isUpgrade = saleType === 'upgrade'
    const isNewSale = saleType === 'sale'
    const title = isUpgrade ? "Upgrade" : "Sale"

    const minDate = deal.trial_coaching_session ? moment(deal.trial_coaching_session.at).startOf('day').toDate() : moment(deal.created_at).startOf('day').toDate()
    let maxDate = moment().endOf('day').toDate()
    if (maxDate <= minDate) maxDate = minDate

    const validationSchema = Yup.object().shape({
      sale_made_by: Yup.string().required("is required"),
      plan_duration: Yup.string().required("Plan duration is required"),
      plan_payments: Yup.string().required("Plan payments is required"),
      value_of_sale: Yup.number().required("Plan payments is required").typeError('value must be a number').min(1, 'must have a value'),
      amount_paid_at_appointment: Yup.number().required("Plan payments is required").typeError('amount must be a number').min(0, 'cant be less than zero'),
      notes_coach: Yup.string().required("Notes for Coach are required").min(15, "minimum 15 characters").max(2000, "maximum 2000 characters"),
      notes_admin: Yup.string().required("Admin Notes are required").min(15, "minimum 15 characters").max(2000, "maximum 2000 characters"),
      sale_from: Yup.string().required("is required"),
      date_of_sale: Yup.date()
        .min(minDate, `sale date must be on or after ${moment(minDate).format("DD MMM YYYY")}`)
        .max(maxDate, `sale date must be on or before today`)
    });
    const { users } = this.state

    const welcomeCallUrl = `https://calendly.com/d/wzcm-wh5c/student-zoom-welcome-call` // ?name=${deal.lm_contact.student_first_name}&Student%20Last%20Name=&LM%20ID=${deal.lm_contact.lm_contact_id}&Year%20Level%20dropdown=10&ParentFullName=${deal.lm_contact.first_name}&Parent%20Last%20Name=&Parent%20Mobile=${deal.lm_contact.mobile}&Email=${deal.lm_contact.email}&Street%20Address=&Suburb=&Postal%20Address=`.replace(/ /g, "%20")
    const paymentUrl = `https://emersoncoaching.com.au/cc/?${queryString.stringify(deal.lm_contact)}`
    return (
      <Formik
        initialValues={{
          sale_made_by: authStore.profile.email,
          plan_duration: deal.plan_duration || '1year',
          plan_payments: deal.plan_payments || '',
          value_of_sale: deal.value_of_sale || 0,
          amount_paid_at_appointment: deal.amount_paid_at_appointment || 0,
          notes_admin: deal.notes_admin || '',
          notes_coach: deal.notes_coach || `What is the desired ATAR / Course the student wishes to achieve?\n\nWhat is the #1 subject which the student wants to improve in?\n\nWhat is the biggest challenge the student has when it comes to studying?\n\nCoach notes\n\n`,
          sale_from: '',
          date_of_sale: new Date()
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          const { onSubmit } = this.props
          const { deal } = this.props
          DealsService.takeAction(saleType + '_made', deal.id, values)
            .then(data => {
              Alert.success('Completed')
              onSubmit(data)
              setSubmitting(false);
            });
        }}
        render={({
          errors,
          touched,
          isValid,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          values
        }) => (
            <Form>
              <div style={{ padding: '6px 10px', margin: '0 0 10px 0', border: '2px solid #ddd', borderRadius: 4 }}>
                <h4 style={{ marginTop: 0 }}>Final Sale Checklist... <span style={{ fontSize: 16 }}>if you haven't done these things, please explain why not in Admin Notes</span></h4>
                <div className='row'>
                  <div className='col-sm-4'>Welcome Call or 1st Session?
                    <div style={{ marginTop: 6, marginBottom: 16 }}>
                      <div><a className='btn btn-info btn-xs' href={welcomeCallUrl} target='_blank' rel="noopener noreferrer" >
                        Book Welcome Call
                      </a></div>
                    </div>
                  </div>
                  <div className='col-sm-4'>Did you process the payment?
                    <div style={{ marginTop: 6, marginBottom: 16 }}>
                      <a className='btn btn-info btn-xs' href={paymentUrl} target='_blank' rel="noopener noreferrer" >
                        Process Payment
                      </a>
                    </div>
                  </div>
                  <div className='col-sm-4'>Completed contracts?
                    <div style={{ marginTop: 6, marginBottom: 16 }}>
                      <a className='btn btn-info btn-xs' href='https://www.meridianone.com.au/join' target='_blank' rel="noopener noreferrer" >Contract Form</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-4'>
                  <FormikFormControl fieldName='date_of_sale' errors={errors} touched={touched}>
                    <ControlLabel>Date of {title}</ControlLabel>
                    <FormikDatetime
                      field="date_of_sale"
                      input={{
                        value: moment(values.date_of_sale).format("dddd DD MMM YYYY"),
                        onChange: setFieldValue,
                        onBlur: setFieldTouched
                      }}
                      closeOnSelect={true}
                      dateFormat="dddd DD MMM YYYY"
                      timeFormat={false}
                      className='datetime-input-small'
                      isValidDate={(current) => current.isSameOrAfter(minDate) && current.isSameOrBefore(maxDate)}
                    />
                  </FormikFormControl>
                </div>
                <div className='col-sm-4'>
                  <FormikFormControl fieldName='sale_made_by' errors={errors} touched={touched}>
                    <ControlLabel>{title} made by</ControlLabel>
                    {users && <Field className="form-control input-sm" name="sale_made_by" component="select">
                      <option value=''>-- select --</option>
                      {users && users.map((user) => { return <option key={user.email} value={user.email}>{user.name}</option> })}
                    </Field>}
                  </FormikFormControl>
                </div>
                <div className='col-sm-4'>
                  <FormikFormControl fieldName='sale_from' errors={errors} touched={touched}>
                    <ControlLabel>{title} from?</ControlLabel>
                    <Field className="form-control input-sm" name="sale_from" component="select">
                      <option value=''>-- select --</option>
                      {isNewSale && <option value='tcs_presentation'>Trial Coaching Session Presentation</option>}
                      {isNewSale && <option value='follow_up'>Follow Up Call</option>}
                      {isUpgrade && <option value='upgrade_call'>Upgrade Call</option>}
                      <option value='admin'>Admin Call (detail in notes)</option>
                      <option value='other'>Other (detail in notes)</option>
                    </Field>
                  </FormikFormControl>
                </div>
              </div>

              <div className='row'>
                <div className='col-sm-6'>
                  <FormikFormControl fieldName='plan_duration' errors={errors} touched={touched}>
                    <ControlLabel>Plan duration</ControlLabel>
                    <Field className="form-control input-sm" name="plan_duration" component="select">
                      <option value=''>-- select --</option>
                      <option value='3month'>3 months</option>
                      <option value='6month'>6 months</option>
                      <option value='1year'>1 Year</option>
                      <option value='2year'>2 Years</option>
                      <option value='3year'>3 Years</option>
                      <option value='other'>Other</option>
                    </Field>
                  </FormikFormControl>
                </div>
                <div className='col-sm-6'>
                  <FormikFormControl fieldName='plan_payments' errors={errors} touched={touched}>
                    <ControlLabel>Plan payments</ControlLabel>
                    <Field className="form-control input-sm" name="plan_payments" component="select">
                      <option value=''>-- select --</option>
                      <option value='upfront'>100% Upfront</option>
                      <option value='2pay'>2 equal payments, 30 days apart</option>
                      <option value='3pay'>3 equal payments, 30 days apart</option>
                      <option value='monthly'>Deposit, then 12 monthly payments</option>
                      <option value='other'>Other (please explain clearly in notes for Admin)</option>
                    </Field>
                  </FormikFormControl>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-6'><FormikInputControl fieldLabel='Value of sale' fieldType='number' fieldName='value_of_sale' errors={errors} touched={touched} /></div>
                <div className='col-sm-6'><FormikInputControl fieldLabel='Amount paid upfront' fieldType='number' fieldName='amount_paid_at_appointment' errors={errors} touched={touched} /></div>
              </div>

              <div className='row'>
                <div className='col-sm-6'><FormikTextAreaControl fieldLabel='Notes for Coach' fieldName='notes_coach' errors={errors} touched={touched} /></div>
                <div className='col-sm-6'><FormikTextAreaControl fieldLabel='Admin Notes' fieldName='notes_admin' errors={errors} touched={touched} /></div>
              </div>

              <div style={{ marginTop: 20 }}>
                {onCancelSubmit && <Button onClick={onCancelSubmit} bsSize='small'>Whoops, cancel this</Button>}
                <Button className='pull-right' disabled={isSubmitting} type="submit" bsStyle='success' bsSize='small'>Go Ahead and Send for Verification</Button>
              </div>
            </Form>
          )} />

    )
  }
}

export default SaleMadeForm
